import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from "UI/Button";
import TextField from "UI/Form/TextField";
import Time from "UI/Form/Time";

import { scheduleValidation as validate } from "Data/posts/PostValidators";
import Form from "Components/Form";
import Modal from "UI/Modal";

export default class PostScheduleModal extends React.Component
{
    state = {
        busy: false,
    };

    static propTypes = {
        post: PropTypes.object.isRequired,
        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,

        schedulePost: PropTypes.func.isRequired,
    };

    onSubmit = (data) => {
        this.setState({busy: true}, () => {
            this.props.schedulePost(
                this.props.post.id,
                `${data.date} ${data.time}`
            ).then(() => {
                this.props.onClose();
            }).catch(() => {
                this.setState({busy: false})
            });
        });
    };

    defaultDateTime = (post) => {
        const datetime = new Date(post.scheduled_for || new Date());
        const formatted = new Intl.DateTimeFormat('default', {year: 'numeric', month: '2-digit', day: '2-digit'}).format(datetime);
        const bits = formatted.split('/');

        return {
            date: [bits[2], bits[1], bits[0]].join('-'),
            time: new Intl.DateTimeFormat('default', {hour: 'numeric', minute: 'numeric'}).format(datetime)
        };
    };

    render()
    {
        const { open, onClose, post } = this.props;

        const defaults = this.defaultDateTime(post);

        return <Modal open={open} onClose={onClose} className='w-full max-w-md'>
            <Modal.Header>
                Schedule Post
            </Modal.Header>
            <Modal.Content>
                <Form id='post-schedule' defaults={defaults} validate={validate} onSubmit={this.onSubmit}>
                    {(data, onChange, validation) => (
                        <fieldset disabled={this.state.busy} className='flex flex-row space-x-4'>
                            <div className='flex-1'>
                                <TextField
                                    type='date'
                                    id="schedule"
                                    hint='DD/MM/YYYY'
                                    label="Date"
                                    value={data.date}
                                    onChange={onChange('date')}
                                    error={validation.hasErrors('date')}
                                    help={validation.getErrors('date')}
                                />
                            </div>
                            <div className='flex-1'>
                                <Time
                                    id='post_time'
                                    hint='HH:MM'
                                    label="Time"
                                    value={data.time}
                                    onChange={onChange('time')}
                                />
                            </div>
                        </fieldset>
                    )}
                </Form>
            </Modal.Content>
            <Modal.Footer>
                <Button form='post-schedule' busy={this.state.busy} type='primary'>Schedule</Button>
                <Button onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>;
    }
}
